// BASIC GALLERY MODAL 

export const basicGalleryModal = (galleryId, dataOrder, picsCount , currentPicNumber, displayedElemnt, picTitle) =>`
<dialog class="gallery-modal" id="${galleryId}" data-order="${dataOrder}">
    <div class="modal-head">
        <div class="gong-logo"><a href=""><img width="160" src="https://m.netinfo.bg/gong/images/content/g25/logo/gong_logo_classic.svg"></a></div>
        <div class="close-button">
            <svg class="icon close"><use xlink:href="#icon-x"></use></svg>
        </div>
    </div>
    <div class="pic-wrap">
        <div class="gallery-picture">
            ${displayedElemnt}
        </div>        
        <div class="click-area-back">
            <div class="view-back">
                <svg class="icon arrow-left"><use xlink:href="#icon-arrow_right"></use></svg>
            </div>
        </div>
        <div class="click-area-next">
            <div class="view-next">
                <svg class="icon arrow-right"><use xlink:href="#icon-arrow_right"></use></svg>
            </div>
        </div>
    </div>
    <div class="pic-info">
        <div class="current-pic">
            ${currentPicNumber}
        </div>
        <div class="pics-count">
            /<span>${picsCount}</span>
        </div>
        <div class="pic-title">${picTitle}</div>
    </div>
    <div class="demo high-wrapper">
        <div class="banner position-atf">
            <div class="banner-300x600">
                <div id='div-gpt-ad-1522667245490-4'></div>
            </div>
        </div>
    </div>    
</dialog>`;
